module.exports = __webpack_public_path__ + "media/images/heart-success-642f213700621b0148609e1f8445249a.svg";